export default (that) => [
  {
    text: that.$l('menu_text_update_shipped') || '更新出货数量',
    icon: 'el-icon-edit',
    menuType: 'updateShipped',
    allow: 'U',
    disabled: ({ hxPurchaseStatus }) => {
      return ['N'].includes(hxPurchaseStatus)
    },
  },
]
